import SunIcon from "./SunIcon";

function SunPathRenderer({ width, height, padding, angle, sunLightRanges }) {
  const drawingAreaHalfWidth = width / 2 - padding * 2;
  const drawingAreaHalfHeight = height / 2 - padding * 2;

  const sunPosition = {
    x:
      width / 2 +
      drawingAreaHalfWidth * Math.cos(((angle - 90) * Math.PI) / 180),
    y:
      height / 2 +
      drawingAreaHalfHeight * Math.sin(((angle - 90) * Math.PI) / 180),
  };

  const startAngle = 0;
  const endAngle = 180;
  const dashAngle = 15;

  const getPath = (start, end) => {
    const startX =
      width / 2 + drawingAreaHalfWidth * Math.cos((start * Math.PI) / 180);
    const startY =
      height / 2 + drawingAreaHalfHeight * Math.sin((start * Math.PI) / 180);
    const endX =
      width / 2 + drawingAreaHalfWidth * Math.cos((end * Math.PI) / 180);
    const endY =
      height / 2 + drawingAreaHalfHeight * Math.sin((end * Math.PI) / 180);
    return `M${startX},${startY} A${drawingAreaHalfWidth},${drawingAreaHalfHeight} 0 0,1 ${endX},${endY}`;
  };

  const getAngleFromHour = (hour) => (hour - 6) * 15;

  // Oblicz zakresy, które nie są pokryte przez sunLightRanges
  const fullRange = [7, 17];
  let uncoveredRanges = [];
  let currentStart = fullRange[0];

  sunLightRanges.forEach((range) => {
    if (range[0] > currentStart) {
      uncoveredRanges.push([currentStart, range[0]]);
    }
    currentStart = range[1];
  });

  if (currentStart < fullRange[1]) {
    uncoveredRanges.push([currentStart, fullRange[1]]);
  }

  return (
    <g id="sun_path">
      <path
        id="06-07"
        d={getPath(startAngle, startAngle + dashAngle)}
        fill="none"
        stroke="#aaa"
        strokeWidth="1"
        strokeDasharray="10,5"
      />
      {uncoveredRanges.map((range, index) => (
        <path
          key={`uncovered-${index}`}
          d={getPath(getAngleFromHour(range[0]), getAngleFromHour(range[1]))}
          fill="none"
          stroke="#aaa"
          strokeWidth="1"
        />
      ))}
      {sunLightRanges.map((range, index) => (
        <path
          key={index}
          d={getPath(getAngleFromHour(range[0]), getAngleFromHour(range[1]))}
          fill="none"
          stroke="#ffd000"
          strokeWidth="4"
        />
      ))}
      <path
        id="17-18"
        d={getPath(endAngle - dashAngle, endAngle)}
        fill="none"
        stroke="#aaa"
        strokeWidth="1"
        strokeDasharray="10,5"
      />
      <SunIcon x={sunPosition.x - 16} y={sunPosition.y - 16} size={32} />
    </g>
  );
}

export default SunPathRenderer;
